  import React, { useState, useEffect, useRef } from "react";
import { FaDownload, FaCheckCircle, FaUsers, FaProjectDiagram, FaBriefcase } from "react-icons/fa";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AboutUs.css";

const AboutUs = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [counts, setCounts] = useState({ clients: 0, projects: 0, employees: 0 });
  const [scrolled, setScrolled] = useState(false);
  const contentRef = useRef(null);
  const statRef = useRef(null);


  
  // Scroll Detection to trigger counting
  useEffect(() => {
    const onScroll = () => {
      const statElement = statRef.current;
      if (statElement) {
        const rect = statElement.getBoundingClientRect();
        if (rect.top <= window.innerHeight) {
          setScrolled(true);
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Animate Numbers (with delay)
  useEffect(() => {
    if (scrolled) {
      const targetCounts = { clients:17, projects: 10, employees: 5 };
      let interval = setInterval(() => {
        setCounts((prev) => ({
          clients: prev.clients < targetCounts.clients ? prev.clients + 1 : prev.clients,
          projects: prev.projects < targetCounts.projects ? prev.projects + 1 : prev.projects,
          employees: prev.employees < targetCounts.employees ? prev.employees + 1 : prev.employees,
        }));
      }, 50);
      return () => clearInterval(interval);
    }
  }, [scrolled]);

  const downloadPDF = () => {
    // Link to the pre-generated PDF
    const pdfUrl = "/Iklim_Company_Profile.pdf"; // The file should be in the 'public' folder
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "Iklim_Digitals_Profile.pdf"; // Optional: specify the download filename
    link.click();
  };
  
  

  // Toggle accordion
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div ref={contentRef} className="container-fluid p-0">
      {/* Hero Section */}
      <div className="hero-section-about text-center text-light d-flex align-items-center">
        <div className="container">
          <h1 className="fw-bold-h1">Welcome to Iklim Digitals</h1>
          <p className="lead">Lead in the Digital Age !</p>
          <button className="btn btn-warning btn-lg mt-3 p-3" onClick={downloadPDF}>
  <FaDownload className="me-2" /> Download Our Profile
</button>

        </div>
      </div>

{/* About Us Section */}
<div className="container py-5 text-center">
  <h2 className="fw-bold">About Us</h2>
  <p className="text-mute">Your Success, Our Expertise</p>

  <div className="row mt-4 d-flex align-items-stretch">
    {/* Who We Are */}
    <div className="col-md-4 mb-4">
      <div className="card shadow-sm p-4 h-100">
        <h4 className="fw-bold">Who We Are</h4>
        <p>We are Iklim Digitals, a creative agency from Ethiopia helping brands lead in the digital age through culture, creativity, and data.</p>
      </div>
    </div>
    {/* Our Mission */}
    <div className="col-md-4 mb-4">
      <div className="card shadow-sm p-4 h-100">
        <h4 className="fw-bold">Our Mission</h4>
        <p>To help brands grow with creative, cultural, and data-driven digital marketing that builds trust and impact.</p>
      </div>
    </div>
    {/* What We Do */}
    <div className="col-md-4 mb-4">
      <div className="card shadow-sm p-4 h-100">
        <h4 className="fw-bold">What We Do</h4>
        <ul className="list-unstyled ps-3">
          <li className="d-flex align-items-center"><FaCheckCircle className="text-success me-2" /> Branding</li>
          <li className="d-flex align-items-center"><FaCheckCircle className="text-success me-2" /> Digital Advertising</li>
          <li className="d-flex align-items-center"><FaCheckCircle className="text-success me-2" /> Content Production</li>
          <li className="d-flex align-items-center"><FaCheckCircle className="text-success me-2" /> Website Development</li>
          <li className="d-flex align-items-center"><FaCheckCircle className="text-success me-2" /> Social Media Marketing</li>
          <li className="d-flex align-items-center"><FaCheckCircle className="text-success me-2" /> Halal Wedding</li>
        </ul>
      </div>
    </div>
  </div>
</div>



     {/* Why Choose Us Section */}
<div className="container py-5">
  <h2 className="text-center fw-bold">Why Partner With Us?</h2>
  <div className="accordion mt-4" id="whyChooseUs">
    {[
      {
        title: "Digital Mastery",
        description:
          "We combine culture, creativity, and technology to craft digital experiences that help your brand lead, stand out, and connect meaningfully with your audience.",
      },
      {
        title: "Data-Driven Decisions",
        description:
          "We turn insights from data into actionable strategies, ensuring every digital move your brand makes is smart, targeted, and effective.",
      },
      {
        title: "Results That Drive Growth",
        description:
          "We focus on delivering measurable outcomes that increase engagement, expand reach, and grow your brand’s influence and business impact.",
      },
      {
        title: "Reliable Support",
        description:
          "We provide end-to-end, reliable support to guide your brand at every stage — from strategy to execution — ensuring your digital efforts stay on track and deliver results.",
      },
    ].map((item, index) => (
      <div key={index} className="accordion-item">
        <h2 className="accordion-header">
          <button
            className={`accordion-button ${openIndex === index ? "" : "collapsed"}`}
            onClick={() => toggleAccordion(index)}
          >
            {item.title}
          </button>
        </h2>
        {openIndex === index && (
          <div className="accordion-body">
            <p>{item.description}</p>
          </div>
        )}
      </div>
    ))}
  </div>
</div>

      {/* Animated Statistics Section */}
      <div ref={statRef} className="container py-5 text-center">
        <div className="row">
          <div className="col-md-4">
            <div className="stat-box">
              <FaUsers className="stat-icon" />
              <h3>{counts.clients}+</h3>
              <p>Satisfied Clients</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stat-box">
              <FaProjectDiagram className="stat-icon" />
              <h3>{counts.projects}+</h3>
              <p>Projects Completed</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stat-box">
              <FaBriefcase className="stat-icon" />
              <h3>{counts.employees}+</h3>
              <p>Employees</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section text-center py-5">
        <h2>Let's Start Your Project Today</h2>
        <p>Contact us for a free consultation</p>
        <a href="tel:+251902340084" className="btn">📞 Call Now</a>
      </div>
    </div>
  );
};

export default AboutUs;
